'use strict';

export default class Accordion {
	constructor(root) {
		this.root = root;
		if (!this.root) return false;
		this._matchHTML();
		this._handler();
	}

	_matchHTML(){
		this.heading = this.root.querySelector('[data-accordion-heading]');
		this.body = this.root.querySelector('[data-accordion-body]');
	}

	_handler(){
		this.heading.addEventListener('click', e => {
			e.preventDefault();

			if (!(this.root.classList.contains('is-active'))){
				this.root.classList.add('is-active');
				$(this.body).slideDown(250, _ => {this.body.classList.add('is-active')});
			} else {
				this.root.classList.remove('is-active');
				$(this.body).slideUp(250, _ => {this.body.classList.remove('is-active')});
			}
		})
	}
}
